import { UserRound } from "lucide-react";
import { getDateMonthTimeFromTimestamp } from "@/lib/utils";
import CommentForm from "./CreateCommentForm";

const UserTaskData = ({
	taskHistory,
	index,
	expandedSections,
}: {
	taskHistory: Task;
	index: number;
	toggleArrow: (indx: number) => void;
	expandedSections: Record<string, unknown>;
}) => {
	const CommentCard = ({ userId, message, time }) => {
		return (
			<div className="bg-transparent rounded-lg shadow-sm p-2">
				<div className="flex items-center">
					<div className="h-4 w-4 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-semibold">
						<UserRound size={15} />
					</div>
					<div className="ml-3">
						<h3 className="text-sm text-textColor">{message}</h3>
						<h3 className="text-xs text-textColor">{userId}</h3>
						{time && (
							<span className="text-xs text-gray-500">
								{getDateMonthTimeFromTimestamp(time)}
							</span>
						)}
					</div>
				</div>
			</div>
		);
	};

	return (
		<>
			<div className="flex-1">
				<div className="flex items-center justify-between">
					<div>
						{taskHistory?.department && (
							<p className="text-sm text-gray-400">{taskHistory?.department}</p>
						)}
						<div className="flex flex-col">
							<span className="text-sm text-gray-400">
								<strong>Status:</strong> {taskHistory?.status ? taskHistory?.status : 'pending'}
							</span>
							<span className="text-sm text-gray-400"><strong>Action:</strong> {taskHistory?.variables?.["task.action"] ? taskHistory?.variables?.["task.action"] : 'none'} </span>
              <span className="text-sm text-gray-400">{taskHistory?.date && getDateMonthTimeFromTimestamp(taskHistory?.date)}</span>
						</div>
					</div>
				</div>
				{!expandedSections[index] && (
					<>
						{taskHistory?.comments?.length > 0 && (
							<div>
								{taskHistory?.comments?.map((comment) => (
									<CommentCard
										userId={comment.userId}
										message={comment.message}
										key={comment.id}
										time={comment.time}
									/>
								))}
							</div>
						)}

						{taskHistory.status !== "completed" && (
							<div className="mt-1">
								<CommentForm
									taskId={taskHistory.id}
									processId={taskHistory.processId}
								/>
							</div>
						)}
					</>
				)}
			</div>
		</>
	);
};

export default UserTaskData;
